import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const COMPETITIONS_REQUEST = 'FETCH_COMPETITIONS_REQUEST';
export const COMPETITIONS_FAILURE = 'FETCH_COMPETITIONS_FAILURE';
export const COMPETITIONS_SUCCESS = 'FETCH_COMPETITIONS_SUCCESS';

export const fetchCompetitions = () => {
    return function(dispatch) {
        dispatch(fetchCompetitionsRequest());
        return axios(apiRequestOptions(apiPath.COMPETITIONS.LIST))
            .then(transformHttpResponse)
            .then(response => dispatch(fetchCompetitionsSuccess(response.data)))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(fetchCompetitionsFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const fetchCompetitionsRequest = () => {
    return {
        type: COMPETITIONS_REQUEST,
    }
};

const fetchCompetitionsFailure = (error) => {
    return {
        type: COMPETITIONS_FAILURE,
        error,
    }
};

const fetchCompetitionsSuccess = (data) => {
    return {
        type: COMPETITIONS_SUCCESS,
        data,
    }
};